import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule, MatSelectionListChange } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';

@Component({
  selector: 'app-edit-list',
  templateUrl: './edit-list.component.html',
  styleUrl: './edit-list.component.scss',
  imports: [ 
    MatDialogModule, 
    MatButtonModule, 
    MatCheckboxModule,
    CommonModule,
    FormsModule, 
    MatListModule,
    ReactiveFormsModule, 
    MatSelectModule,
    DragDropModule,
    MatIconModule]
})
export class EditListComponent {
  title: string = "";
  message: string = "";
  data: { list: any[], title: string, description: string, defaultSelected: boolean, getIdFn: (t: any) => any, getItemNameFn: (t: any) => string } = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef);
  selectedOptions = [];
  itemComparer: (a: any, b: any) => boolean;

  constructor() {
    this.title = this.data.title;
    this.message = this.data.description;
    this.itemComparer = typeof this.data.getIdFn === "function" ? (a: any, b: any) => this.data.getIdFn(a) === this.data.getIdFn(b) : (a: any, b: any) => a === b;
  }

  isSelected(item: any) {
    return this.data.defaultSelected ?? false;
  }

  getItemName(item: any) {
    if (typeof this.data.getItemNameFn === "function") return this.data.getItemNameFn(item);
    return item;
  }

  getId(item: any) {
    if (typeof this.data.getIdFn === "function") return this.data.getIdFn(item);
    return item;
  }

  selectionChanged($event: MatSelectionListChange) {
    //console.log($event);
  }

  log($event: any) {
    //console.log($event, this.selectedOptions);
  }
  
  cancel() { this.dialogRef.close(); }
  confirm() {
    const selected = this.selectedOptions;
    const inverse = this.data.list.filter(item => !selected.find(s => this.getId(s) === this.getId(item)));
    this.dialogRef.close({ selected, inverse });
  }
}
